import {
  ESTADO_REVISION_PAGOS_COBROS,
  ESTADO_REVISION_PROPERTIES,
  PAYMENT_TYPE,
} from "common/utils/constants"
import StatusTooltip from "features/Tesoreria/pages/Cartera/components/StatusTooltip"
import { useTranslation } from "react-i18next"

const ModalEstados = ({
  estadoRevisionActual,
  tipoFlujoTesoreria,
  estadoCobro,
  estadoPago,
  iconColor,
  className,
  isFactura,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const estadoRevision = ESTADO_REVISION_PROPERTIES(t)[estadoRevisionActual]
  const settings = ESTADO_REVISION_PAGOS_COBROS(t)[tipoFlujoTesoreria]
  const statusSettings =
    settings?.[
      tipoFlujoTesoreria === PAYMENT_TYPE.COBRO ? estadoPago : estadoCobro
    ]
  return (
    <div
      className={`modal-estados_container ${className || ""} mt-3 pt-2 pb-2`}
    >
      <div className='mb-2 row'>
        <div className='col-lg-6'>
          <span>{t("crear.presupuesto.modal.validationStatusLabel")}</span>
        </div>
        <div
          className='col-lg-6 text-lg-right'
          style={{ color: estadoRevision?.color }}
        >
          {estadoRevision?.text}
        </div>
      </div>
      {isFactura && tipoFlujoTesoreria !== null && statusSettings ? (
        <div className='mb-2 row'>
          <div className='col-lg-6'>
            <span>
              <StatusTooltip
                estado={tipoFlujoTesoreria}
                iconColor={iconColor}
              />
            </span>
          </div>

          <div
            className='col-lg-6 text-lg-right'
            style={{ color: statusSettings?.color }}
          >
            {statusSettings?.text}
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default ModalEstados
